module.exports = __webpack_public_path__ + "static/media/impact.1c23ddbe.svg";